import { todayInKenya, MONTHS, YEARS_OFFERED } from "../../utils/dateOfBirth";
import "./DateOfBirthField.css";

/**
 * Day / month / year as three native selects: the phone's own picker opens
 * for each, there is nothing to type, and no format to get wrong. Years run
 * from this year back YEARS_OFFERED years, newest first; a future year is
 * never offered. Under-age years ARE offered, so the form can say "you need
 * to be at least 18" rather than silently hiding the customer's own year.
 */
const DateOfBirthField = ({ value, onChange, className = "", style, idPrefix = "dob" }) => {
  const thisYear = todayInKenya().year;
  const years = Array.from({ length: YEARS_OFFERED + 1 }, (_, i) => thisYear - i);
  const set = (part) => (e) => onChange({ ...value, [part]: e.target.value });

  return (
    <fieldset className={`form-field dob-field ${className}`.trim()} style={style}>
      <legend>Date of birth</legend>
      <div className="dob-selects">
        <select id={`${idPrefix}-day`} aria-label="Day" className="form-input form-select"
          value={value.day} onChange={set("day")} autoComplete="bday-day">
          <option value="">Day</option>
          {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => <option key={d} value={d}>{d}</option>)}
        </select>
        <select id={`${idPrefix}-month`} aria-label="Month" className="form-input form-select"
          value={value.month} onChange={set("month")} autoComplete="bday-month">
          <option value="">Month</option>
          {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
        </select>
        <select id={`${idPrefix}-year`} aria-label="Year" className="form-input form-select"
          value={value.year} onChange={set("year")} autoComplete="bday-year">
          <option value="">Year</option>
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
    </fieldset>
  );
};

export default DateOfBirthField;
